import { StandaloneReviewsScore } from './StandaloneReviewsScore'

export default StandaloneReviewsScore
